import { getData } from "./index.svc"

export const getCodes = async () => {
    return await getData('codes')
}